"use client";

import { Button, SubmitButton } from "@/components/ui/button";
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@/components/ui/modal";

interface Props {
  target: { name: string } | null;
  body: string;
  pending: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
}

/**
 * Archiving a scorecard type is reversible from the same list (Restore), so
 * this confirms in one click instead of the shared `ArchiveConfirmModal`'s
 * type-the-name gate — same Modal shell and destructive footer either way.
 */
export function ArchiveConfirmModal({ target, body, pending, onCancel, onConfirm }: Props) {
  return (
    <Modal
      open={Boolean(target)}
      dismissible={!pending}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    >
      <ModalContent size="sm">
        <ModalHeader
          title={target ? `Archive "${target.name}"?` : "Archive?"}
          iconName="IconArchive"
        />
        <ModalBody className="p-5">
          <p className="text-sm leading-normal text-contrast/60">{body}</p>
        </ModalBody>
        <ModalFooter className="px-5">
          <Button type="button" variant="secondary" size="sm" onClick={onCancel} disabled={pending}>
            Cancel
          </Button>
          <SubmitButton
            type="button"
            variant="destructive"
            size="sm"
            loading={pending}
            loadingLabel="Archiving"
            onClick={() => void onConfirm()}
          >
            Archive
          </SubmitButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
